<template>
  <div :class="$style.container" ref="page">
    <div :class="$style.tips">
      <p>温馨提示</p>
      <p>1. 本月可开发票只针对服务费以及注册费。</p>
      <p>2. 本月产生的服务费以及注册费在下个月二号以后才可以索取发票。</p>
      <p>3. 发票基于订单开具，不可拆分开票。</p>
      <p>
        4. 识道网络单张发票金额限额100万，索取金额超过100万将拆分成多张发票开具。
      </p>
    </div>

    <Divider />
    <Loading v-show="!showDetail" :loading="loading" :text="loadingText">
      <!-- 发票信息搜索参数 -->
      <Row>
        <Item title="发票类型">
          <el-select v-model="invoiceType" placeholder="全部">
            <el-option
              v-for="(item, index) in invoiceTypeList"
              :key="index"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </Item>

        <Item title="开具类型">
          <el-select v-model="issuingType" placeholder="全部">
            <el-option
              v-for="(item, index) in issuingTypeList"
              :key="index"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </Item>

        <Item title="发票抬头">
          <el-input :class="$style.header" v-model.trim="header"></el-input>
        </Item>

        <Button :class="$style.btn" type="primary" @click="submitSearch(1)">
          查询
        </Button>
        <Button :class="$style.btn" @click="resetSearch">重置</Button>
      </Row>

      <!-- 发票管理搜索结果 -->
      <Title title="搜索结果" :count="total" />

      <el-table
        ref="multipleTable"
        :data="showList"
        :fit="true"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column prop="header" label="发票抬头" align="center" />
        <!-- <el-table-column prop="header" label="开具类型" align="center" /> -->

        <el-table-column label="开具类型" align="center">
          <template slot-scope="scope">
            {{ scope.row.issuingType == 0 ? "个人" : "企业" }}
          </template>
        </el-table-column>

        <el-table-column label="发票类型" align="center">
          <template slot-scope="scope">
            {{
              scope.row.invoiceType == 0 ? "增值税普通发票" : "增值税专用发票"
            }}
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <div :class="$style.action_btn">
              <span @click="toDetail(scope.row.id)">详情</span>
              <span
                v-if="scope.row.status < 3"
                @click="cancelInvoice(scope.row.id)"
                >取消</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </Loading>
  </div>
</template>

<script>
import { getInvoiceInfoData } from "@server";
export default {
  data() {
    return {
      showDetail: false,
      loading: false,
      loadingText: "加载中",

      invoiceTypeList: [
        {
          name: "增值税普通发票",
          value: 0,
        },
        {
          name: "增值税专用发票",
          value: 1,
        },
      ],
      invoiceType: null,
      issuingTypeList: [
        {
          name: "个人",
          value: 0,
        },
        {
          name: "企业",
          value: 1,
        },
      ],
      issuingType: null,
      header: "",

      page: 1,
      limit: 50,
      showList: [],
      total: 0,
    };
  },
  created() {
    this.submitSearch();
  },
  methods: {
    async submitSearch(page = 1) {
      this.loading = true;
      this.page = page;

      const params = {
        page,
        limit: this.limit,
        header: this.header,
        invoiceType: this.invoiceType,
        issuingType: this.issuingType,
      };

      const res = await getInvoiceInfoData(params);
      const { code, data } = res;
      if (code === 200) {
        this.showList = data.list;
        this.total = data.total;
      }
      this.loading = false;
    },

    resetSearch() {
      this.status = "";
      this.startTime = "";
      this.endTime = "";
      this.submitSearch();
    },
  },
};
</script>
<style lang="scss" module scoped>
.container {
  min-height: 300px;
  position: relative;

  .tips {
    font-size: rem(14);
    color: #333;
    line-height: 32px;
    padding-bottom: rem(40);

    p:first-child {
      font-size: max(rem(16), 14px);
      font-weight: bold;
    }
  }

  :global {
    .gl-row {
      padding: rem(30) 0;
    }
    .gl-item {
      margin-right: rem(40);
    }
    .el-pagination {
      @include flex();
      margin-top: rem(50);
    }
  }

  .divider {
    width: 6px;
    height: 1px;
    background: #333;
    margin: 0 7px;
  }

  .action_btn {
    @include flex();
    gap: 20px;

    span {
      font-size: rem(14);
      color: #333;
      cursor: pointer;

      &:hover {
        color: $theme-color;
      }
    }
  }

  .btn {
    min-width: rem(80);
  }

  .btn_back {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 16px;
    color: $theme-color;
    background-color: #fff;
    border: 1px solid $theme-color;
    transform: scale(0.8);
    transition: all 0.1s;

    &:hover {
      background-color: rgba(255, 92, 53, 0.1);
    }
  }
}
</style>

